import {useNavigate} from "react-router-dom";
import {AppPage} from "common/Layout";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppTitle} from "shared/UI/UIKit/Title";
import {AppUniversalContentBlock} from "shared/UI/UIKit/UniversalContentBlock";
import {
  getHomeUrl,
  getAnnotationUrl,
  getInteractiveUrl,
  getLiteratureUrl,
  getMethodologicalModuleUrl, getPracticalModuleUrl,
  getTargetUrl, getTestUrl, getTheoryUrl, getVideoUrl, getAdditionalMaterialsUrl
} from "services/navigation";
import type {
  Page, AnnotationPage as AnnotationPageType, InteractivePage,
  MethodologicalModulePage as MethodologicalModulePageType, PracticalModulePage as PracticalModulePageType
  , UniversalContentItem as UniversalContentItemType
} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const AnnotationPage = () => {
  const navigate = useNavigate();
  const annotationPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.ANNOTATION) as AnnotationPageType;
  const blockAnnotationPart = annotationPage.content.find(item => item.type === "block") as UniversalContentItemType;
  const tableAnnotationParts = annotationPage.content.filter(item => item.type === "table") as UniversalContentItemType[];

  if (!annotationPage) {
    return null;
  }

  const getUrl = (page: Page) => {
    switch (page.type) {
      case PageType.ANNOTATION:
        return getAnnotationUrl();
      case PageType.INTERACTIVE:
        return getInteractiveUrl({id: (page as InteractivePage).id});
      case PageType.LITERATURE:
        return getLiteratureUrl();
      case PageType.TARGET:
        return getTargetUrl();
      case PageType.TEST:
        return getTestUrl();
      case PageType.THEORY:
        return getTheoryUrl();
      case PageType.VIDEO:
        return getVideoUrl();
      case PageType.METHODOLOGICAL_MODULE:
        return getMethodologicalModuleUrl({id: (page as MethodologicalModulePageType).id});
      case PageType.PRACTICAL_MODULE:
        return getPracticalModuleUrl({id: (page as PracticalModulePageType).id});
      case PageType.ADDITIONAL_MATERIALS:
        return getAdditionalMaterialsUrl();
      default:
        return getHomeUrl();
    }
  };

  const goToNextPage = () => {
    const nextPage = GLOBAL_CONFIG.pages.find(page => page.order === annotationPage.order + 1);

    if (nextPage) {
      const url = getUrl(nextPage);
      navigate(url);
    }
  };

  return (
    <AppPage
      contentClassName={styles.content}
      pageTitle="Аннотация"
      documentTitle="Аннотация"
      style={{backgroundImage: `url(${annotationPage.imagePath})`}}
    >
      <AppFlex unit="30">
        <AppText size={24} className={styles.mainTitle}>Аннотация</AppText>
        <div className={styles.block}>
          <AppUniversalContentBlock item={blockAnnotationPart}/>
        </div>
        <div className={styles.table}>
          {tableAnnotationParts.map((item, index) => (
            <div className={styles.tableRow} key={index}>
              <div className={styles.tableRowTitle}>
                <AppTitle level={2}>{item.title}</AppTitle>
                {item?.subtitle && (<AppText size={20}>{item.subtitle}</AppText>)}
              </div>
              <div className={styles.tableRowData}>
                <AppUniversalContentBlock item={item}/>
              </div>
            </div>
          ))}
        </div>
      </AppFlex>
      <AppButton className={styles.nextPageBtn} onClick={goToNextPage}>
        {annotationPage.nextBtnName}
      </AppButton>
    </AppPage>
  );
};
